/* eslint-disable */
import React, { useEffect, useState } from "react";
// import { IntroSection } from './styles';
import { Content, Logo, Model, ModelContainer } from "./styles";
import AutoInfiniteSlider from "./Slider";
import axios from "axios";
import { Button } from "../../components";
import moment from "moment-timezone";
const Home1 = ({
  IsValid,
  setIsValid,
  Times,
  setDurationId,
  setPlanName,
  setShow,
  setProdId,
  setPrice,
  productsForNew,
  setproductsForNew,
  SelectedCategory,
  setSelectedCategory,
  SelectedNAme,
  setSelectedNAme,
  HasSubCategory,
  setHasSubCategory,
  SubCat,
  setSubCat,
}) => {
  const [OpenTree, setOpenTree] = useState(false);
  var x = localStorage.getItem("name");
  const emailId = localStorage.getItem("emailId");

  const callOffers = () => {
    const body = {
      email: emailId,
      name: x,
      phone: "",
    };
    axios.post(
      `${process.env.REACT_APP_BASEURL}tata/website/user/redeem/logger`,
      body
    );
  };
  console.log("HR");
  useEffect(() => {
    const email = new URLSearchParams(window.location.search).get("email");
    console.log("email", email);
    // if (email) localStorage.setItem('userEmail', email);
    var cnt = 0;
    const urlString = window?.location?.href;
    let paramString = urlString.split("?")[1];
    let queryString = new URLSearchParams(paramString);
    // for (let pair of queryString.entries()) {
    //   localStorage.setItem(pair[0], pair[1]);
    //   console.log('Key is:' + pair[0]);
    //   console.log('Value is:' + pair[1]);
    //   cnt++;
    // }
    localStorage.setItem("noOfPeople", cnt);
    const res = new URLSearchParams(window.location.search).get("resource");
    if (window.location.href.includes("product") === false && IsValid === true)
      setOpenTree(true);
  }, [IsValid]);

  const timezone = "Asia/Kolkata";

  const today = moment.tz(timezone).startOf("day");
  const secondJuly = moment
    .tz(timezone)
    .month(6) // July (0-based)
    .date(1)
    .startOf("day");

  const tweleJuly = moment
    .tz(timezone)
    .month(6) // July (0-based)
    .date(12)
    .startOf("day");

  const isAfter2ndJuly = today.isAfter(secondJuly);
  const isBefore12thJuly = today.isBefore(tweleJuly);

  console.log("Is After 2nd July 2026", isAfter2ndJuly);
  console.log("Is Before 12th July 2026", isBefore12thJuly);

  // const images = [
  //   IsValid ? { id: 4, link: 'assets/card 5.jpg' } : null,
  //   !IsValid ? { id: 1, link: 'assets/card 1.jpg' } : null,
  //   !IsValid ? { id: 2, link: 'assets/card 2.jpg' } : null,
  //   !IsValid ? { id: 3, link: 'assets/card 3.jpg' } : null,
  //   !IsValid ? { id: 4, link: 'assets/card 4.jpg' } : null
  // ].filter((item) => item !== null);
  const images =
    isAfter2ndJuly && isBefore12thJuly
      ? [
          // { id: 5, link: "assets/card 6.jpg" },
          // { id: 1, link: 'assets/card 1.jpg' },
          // { id: 2, link: 'assets/card 2.jpg' },
          // { id: 3, link: 'assets/card 3.jpg' },
          // { id: 4, link: 'assets/card 4.jpg' },
          { id: 5, link: "assets/DNA Prime New.png" },
        ]
      : [
          { id: 1, link: "assets/card 1.jpg" },
          { id: 2, link: "assets/card 2.jpg" },
          { id: 3, link: "assets/card 3.jpg" },
          { id: 4, link: "assets/card 4.jpg" },
        ];

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    // Add event listener on component mount
    window.addEventListener("resize", handleResize);

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function Countdown({ endTime }) {
    const [countdown, setCountdown] = useState("");

    useEffect(() => {
      let countdownInterval;

      function updateCallback(countdownValue) {
        setCountdown(countdownValue);
      }

      startCountdown(endTime, updateCallback, countdownInterval);

      // Cleanup the interval when the component unmounts
      return () => clearInterval(countdownInterval);
    }, [endTime]);

    return (
      <div
        style={{
          background: "#0D85C3",
          height: screenWidth < 800 ? 30 : 60,
          color: "#fff",
          padding: "10px",
          fontSize: screenWidth < 800 ? 10 : 30,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            marginLeft: 15,
          }}
        >
          <div
            style={{
              width: screenWidth < 800 ? 78 : 230,
              marginRight: 10,
              marginLeft: screenWidth < 800 ? 0 : 90,
            }}
          >
            {countdown}
          </div>{" "}
          <div>Left for the Offer</div>
        </div>
        <div
          style={{
            marginRight: screenWidth < 800 ? 10 : 90,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            onClick={() => {
              const divide = PlanForUnlockMe[0];
              setDurationId(divide.duration_id);
              setPlanName(divide.package_title);
              setShow(true);
              setProdId(divide.package_id);
              setPrice(divide.special_price);
              callOffers();
            }}
            style={{
              border: "none",
              color: "#0D85C3",
              background: "#ffff",
              padding: "8px 18px",
              outline: "none",
              fontSize: screenWidth < 800 ? 10 : 18,
              borderRadius: 5,
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Redeem Now
          </div>
        </div>
      </div>
    );
  }

  function startCountdown(endTime, updateCallback, interval) {
    function update() {
      const currentTime = new Date().getTime();
      const endDate = new Date(endTime).getTime();

      if (currentTime >= endDate) {
        clearInterval(interval);
        setIsValid(false);
        updateCallback("Countdown has ended");
      } else {
        const timeDifference = endDate - currentTime;

        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        const formattedHours = String(hours).padStart(2, "0");
        const formattedMinutes = String(minutes).padStart(2, "0");
        const formattedSeconds = String(seconds).padStart(2, "0");

        updateCallback(
          `${formattedHours}  :  ${formattedMinutes}  :  ${formattedSeconds}  hrs`
        );
      }
    }

    // Initial update
    update();

    // Update the countdown every second
    interval = setInterval(update, 1000);
  }

  return (
    <div style={{ marginTop: screenWidth < 800 ? 73 : 97 }}>
      {/* {IsValid && <Countdown startTime={Times.startTime} endTime={Times.endTime} />} */}
      <AutoInfiniteSlider
        images={images}
        productsForNew={productsForNew}
        setproductsForNew={setproductsForNew}
        SelectedCategory={SelectedCategory}
        setSelectedCategory={setSelectedCategory}
        SelectedNAme={SelectedNAme}
        setSelectedNAme={setSelectedNAme}
        HasSubCategory={HasSubCategory}
        setHasSubCategory={setHasSubCategory}
        SubCat={SubCat}
        setSubCat={setSubCat}
        IsValid={IsValid}
        // setDurationId={setDurationId}
        // setPlanName={setPlanName}
        // setShow={setShow}
        // setProdId={setProdId}
        // setPrice={setPrice}
        // PlanForUnlockMe={PlanForUnlockMe}
        // callOffers={callOffers}
      />
      <Model show={OpenTree}>
        <ModelContainer>
          <Button
            style={{
              borderRadius: "20px",
              position: "absolute",
              top: "0",
              right: "2rem",
              height: "2.3rem",
              width: "2.3rem",
              color: "black",
              backgroundColor: "white",
              padding: " 0.4px 0.5px",
            }}
            onClick={() => setOpenTree(false)}
          >
            X
          </Button>
          <Content>
            <link
              href="https://fonts.googleapis.com/css?family=Tilt Neon"
              rel="stylesheet"
            />
            {/* <div
              style={{
                color: '#0e85c3',
                fontSize: 40,
                fontWeight: 400,
                textAlign: 'center',
                fontFamily: 'Tilt Neon'
              }}>
              Because family always deserves the best.
            </div>
            <div
              style={{
                color: '#0e85c3',
                fontSize: 40,
                fontWeight: 400,
                textAlign: 'center',
                fontFamily: 'Tilt Neon'
              }}>
              Exculsive deals only for YOU!
            </div> */}
            <img
              src="/assets/card 6.jpg"
              height={screenWidth > 800 ? "550" : "200"}
            />
            {/* <img src="/assets/grab now.gif" height="150" /> */}
            {/* <link href="https://fonts.googleapis.com/css?family=Bungee Shade" rel="stylesheet" />
            <div
              style={{
                color: '#000',
                fontSize: 100,
                fontWeight: 400,
                textAlign: 'center',
                fontFamily: 'Bungee Shade'
              }}>
              GRAB NOW
            </div> */}
            {/* <a href="./#product" style={{ textDecoration: 'none' }}>
              <div
                onClick={() => {
                  const DNA = productsForNew.find(
                    (item) => item.category.toLowerCase() === 'dna test'
                  );
                  setOpenTree(false);
                  setSelectedCategory(DNA.category_id);
                  setSelectedNAme(DNA.category);
                  setHasSubCategory(DNA.has_sub_category);
                }}
                style={{
                  background: '#0D85C3',
                  padding: '10px 30px',
                  borderRadius: 50,
                  color: '#fff',
                  cursor: 'pointer',
                  marginTop: 20,
                  fontSize: 25
                }}>
                Explore More
              </div>
            </a> */}
          </Content>
        </ModelContainer>
      </Model>
    </div>
    // <IntroSection.SupperWrapper style={{ marginTop: '70px' }}>
    //   <IntroSection.MainWrapper>
    //     <IntroSection.Wrapper>
    //       <IntroSection.LeftWrapper>
    //         <h2>
    //           Hi, <span style={{ color: '#4286c2' }}>{x}</span>
    //         </h2>
    //         <h1>Why Does This Always Happen To Me?</h1>
    //         <h4>
    //           The answer lies in your DNA. Your genetic code contains all the information you need
    //           to optimize your health holistically.
    //         </h4>
    //         <h3>#ListenToYourDNA</h3>
    //         <br />
    //         <br />
    //         <a href="./#product">
    //           <Button>GET FIT WITH US</Button>
    //         </a>
    //       </IntroSection.LeftWrapper>
    //       <IntroSection.RightWrapper></IntroSection.RightWrapper>
    //     </IntroSection.Wrapper>
    //   </IntroSection.MainWrapper>
    // </IntroSection.SupperWrapper>
  );
};

export default Home1;
